export function validateINN(inn: string): boolean {
  if (!/^\d{12}$/.test(inn)) return false
  
  const digits = inn.split('').map(Number)
  
  // Проверка первого контрольного числа
  const coeff1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]
  const sum1 = coeff1.reduce((sum, coeff, i) => sum + coeff * digits[i], 0)
  if (sum1 % 11 % 10 !== digits[10]) return false
  
  // Проверка второго контрольного числа
  const coeff2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]
  const sum2 = coeff2.reduce((sum, coeff, i) => sum + coeff * digits[i], 0)
  return sum2 % 11 % 10 === digits[11]
}